function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var ModTemplate = require('../../lib/templates/modtemplate');
var PeerService = require('saito-js/lib/peer_service')["default"];
var MailRelay = /*#__PURE__*/function (_ModTemplate) {
  function MailRelay(app) {
    var _this;
    _classCallCheck(this, MailRelay);
    _this = _callSuper(this, MailRelay, [app]);
    _this.description = 'Module to relay Saito email messages onto the legacy email system.';
    _this.categories = 'Communications Utilities';
    _this.name = 'MailRelay';
    _this.slug = 'mailrelay';
    _this.deascription = 'Adds support for integrating on-chain messages with legacy off-chain email notifications';
    _this.categories = 'Core Utilities';
    _this["class"] = 'utility';
    _this.status = 'prod';
    _this.services = [];
    app.connection.on('mailrelay-send-email', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              console.log('mailrelay-send-email request');
              if (_this.services.length > 0) {
                _this.sendMail(data);
              } else {
                _this.sendMailRelayTransaction(data);
              }
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }
  _inherits(MailRelay, _ModTemplate);
  return _createClass(MailRelay, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
        var email;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _superPropGet(MailRelay, "initialize", this, 3)([app]);
            case 1:
              if (!app.BROWSER) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              if (process.env.SENDGRID) {
                this.services.push(new PeerService(null, 'mailrelay', 'Mail Relay Service'));
              }
              if (this.services.length) {
                console.log('I am a mail relay :)');
              } else {
                console.log('I am not a mail relay :(');
              }

              // add an email
              email = {
                to: 'richard@saito.tech',
                from: 'network@saito.tech',
                subject: 'Saito Network Initialised',
                text: ''
              };
              if (app.options.server.endpoint != null) {
                email.text = app.options.server.endpoint.host + ' has spun up.';
              } else {
                email.text = 'Just a quick note to let you know that test net just spun up.';
              }
              this.sendMail(email);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function initialize(_x2) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app, tx, peer, callback) {
        var message;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(tx == null)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, 0);
            case 1:
              message = tx.returnMessage();
              if (!(message.module == this.name)) {
                _context3.n = 2;
                break;
              }
              if (!(message.request == 'send email')) {
                _context3.n = 2;
                break;
              }
              this.sendMail(message.data);
              return _context3.a(2, 1);
            case 2:
              return _context3.a(2, _superPropGet(MailRelay, "handlePeerTransaction", this, 3)([app, tx, peer, callback]));
          }
        }, _callee3, this);
      }));
      function handlePeerTransaction(_x3, _x4, _x5, _x6) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "sendMailRelayTransaction",
    value: function () {
      var _sendMailRelayTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(email) {
        var newtx, peers, _iterator, _step, p, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.n = 1;
              return this.app.wallet.createUnsignedTransaction();
            case 1:
              newtx = _context4.v;
              newtx.msg = {
                module: this.name,
                request: 'send email',
                data: email
              };
              _context4.n = 2;
              return newtx.sign();
            case 2:
              console.log('trying to send email to mail relay...');
              _context4.n = 3;
              return this.app.network.getPeers();
            case 3:
              peers = _context4.v;
              _iterator = _createForOfIteratorHelper(peers);
              _context4.p = 4;
              _iterator.s();
            case 5:
              if ((_step = _iterator.n()).done) {
                _context4.n = 7;
                break;
              }
              p = _step.value;
              if (!p.hasService('mailrelay')) {
                _context4.n = 6;
                break;
              }
              this.app.network.sendTransactionWithCallback(newtx, null, p.publicKey);
              console.log('sent mail request to peer!');
              return _context4.a(2, false);
            case 6:
              _context4.n = 5;
              break;
            case 7:
              _context4.n = 9;
              break;
            case 8:
              _context4.p = 8;
              _t = _context4.v;
              _iterator.e(_t);
            case 9:
              _context4.p = 9;
              _iterator.f();
              return _context4.f(9);
            case 10:
              console.warn('No peers offer mail relay service');
              console.log('unsent email: ', email);
              return _context4.a(2, newtx);
          }
        }, _callee4, this, [[4, 8, 9, 10]]);
      }));
      function sendMailRelayTransaction(_x7) {
        return _sendMailRelayTransaction.apply(this, arguments);
      }
      return sendMailRelayTransaction;
    }() //
    // only servers will have this
    //
  }, {
    key: "sendMail",
    value: function sendMail(email) {
      if (this.app.BROWSER) {
        return;
      }
      console.info('sending email...', email);

      //array of attahments in formats as defined here
      // ref: https://github.com/guileen/node-sendmail/blob/master/examples/attachmentFile.js

      if (email.attachments == undefined) {
        email.attachments = '';
      }
      if (email.ishtml == undefined) {
        email.ishtml = false;
      }
      if (email.bcc == undefined) {
        email.bcc = '';
      }
      if (email.cc == undefined) {
        email.cc = '';
      }
      if (email.text == undefined) {
        email.text = '';
      }
      if (email.subject == undefined) {
        email.subject = '';
      }
      if (email.html == undefined) {
        email.html = '';
      }
      // Put body of email in correct field
      if (email.ishtml) {
        email.html = email.html || email.text;
        email.text = '';
      } else {
        email.text = email.text || email.html;
        email.html = '';
      }
      // Default to from Saito
      if (!email.from) {
        email.from = 'network@saito';
      }
      if (!email.to) {
        console.error('Invalid email: ', email);
        return;
      }
      try {
        var credentials = {};
        if (process.env.SENDGRID) {
          credentials = JSON.parse(process.env.SENDGRID);
        }
        var nodemailer = require('nodemailer');
        var transporter = nodemailer.createTransport(credentials);
        transporter.sendMail(email, function (err, info) {
          if (info) {
            console.log(info.envelope);
            console.log(info.messageId);
          } else {
            console.error(err);
          }
        });
      } catch (err) {
        console.error('Error sending mail: ' + err);
      }
    }
  }, {
    key: "returnServices",
    value: function returnServices() {
      return this.services;
    }
  }]);
}(ModTemplate);
module.exports = MailRelay;